import { Typography } from '@mui/material';
import React from 'react';

interface Props {
    html: string;
}

export const Markdown: React.FC<Props> = (props) => {
    return <Typography component='div' className='markdown' dangerouslySetInnerHTML={{ __html: props.html }} />;
};
